









































import { Vue, Component } from 'vue-property-decorator';
import VoteList from '../components/VoteList.vue';
import { getBaseInfo } from '../api';

@Component({
  components: {
    VoteList,
  },
})
export default class Home extends Vue {
  baseInfo: any = {};
  active = 0;
  tempValue = '';
  searchWords: string = '';
  tabs = [{ text: '社群风采' }, { text: '红人展示' }];

  get showMask() {
    return Date.now() > +this.baseInfo.endTime * 1000;
  }
  async created() {
    const res = await getBaseInfo();
    this.baseInfo = res.data;
  }

  handleClickTab(index: number) {
    this.tempValue = '';
    this.searchWords = '';
    this.active = index;
  }
  handleClickSearch() {
    this.searchWords = this.tempValue;
  }
  enterDetailPage(id: number) {
    this.$router.push({
      path: 'detail',
      query: {
        id: String(id),
        type: String(this.active + 1),
      },
    });
  }
  toApply() {
    window.location.href = 'http://hdxu.cn/dK7oo';
  }
}
